import { inject } from '@angular/core';

import { Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { first } from 'rxjs';
import { map } from 'rxjs';
import { AuthUser } from './auth-user';

export const newUserGuard = () => {
  const user = inject(AuthUser);
  const router = inject(Router);
  const user$ = toObservable(user.data);
  return user$.pipe(
    first((user) => !!user),
    map((user) => {
      if (!user?.roles?.length) {
        return router.createUrlTree(['/onboarding-wizard']);
      }
      return true;
    }),
  );
};
